import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form'
import { success, error, abort  } from 'redux-saga-requests';
import { loadingBarReducer } from 'react-redux-loading-bar'
import { toArray } from '../common/util';
import {
    AUTH,
    DE_AUTH,
    AUTH_REGISTER,
    AUTH_INIT,
    FETCH_FEED,
    POST_FEED,
    FETCH_NEWS,
    FETCH_AWARDS,
    FETCH_AWARD_SUMMARY,
    FETCH_RANKS,
    FETCH_CHAPTERS,
    FETCH_DIVISIONS,
    FETCH_APPLICATION,
    FETCH_USER_APPLICATIONS,
    FETCH_APPLICATION_QUESTIONS,
    FETCH_ACTIVE_APPLICATIONS,
    FETCH_ARCHIVED_APPLICATIONS,
    FETCH_NOTIFICATIONS,
    INIT_SUCCESS,
    POST_STEPTWO_APPLICATION,
    POST_STEPTWO_REDO_APPLICATION,
    POST_STEPONE_REDO_APPLICATION,
    FETCH_NEWS_ITEM,
    FETCH_APPLICATION_INTERESTS,
    POST_ESCALATE_APPLICATION,
    POST_REDO_APPLICATION,
    POST_ACCEPT_APPLICATION,
    POST_REJECT_APPLICATION,
    POST_CLOSE_APPLICATION,
    INIT_RESET,
    FETCH_MEMBERSHIP_HISTORY,
    FETCH_USER_AWARDS,
    FETCH_AWARD_CATEGORIES,
    FETCH_CHAPTER_MEMBERS,
    UPDATE_PROFILE,
    UPDATE_AVATAR,
    SOCKET_ONLINE_USERS,
    FETCH_FEED_ITEM,
    FETCH_CHAPTER_ITEM,
    FETCH_CHAPTER_DIVISION_ITEM,
    FETCH_AWARD_ITEM,
    FETCH_AWARD_CATEGORY_ITEM,
    FETCH_USER,
    FETCH_RANK_ITEM,
    AUTH_VERIFY,
    AUTH_RESET,
    AUTH_GET_RESET,
    NOTIFICATION_ISREAD,
    FETCH_NOTIFICATION_ITEM,
    OPEN_CHAPTER,
    FETCH_CHAPTER_MEMBER_ITEM,
    FETCH_COMMENTS,
    POST_COMMENT,
    FETCH_QUOTES,
    FETCH_QUOTE_ITEM,
    FETCH_CODEX,
    FETCH_CODEX_ITEM,
    POST_CODEX,
    FETCH_DKP_SECTION_ITEM,
    FETCH_DKP_SECTIONS,
    FETCH_DKP_SECTION_STANDINGS,
    FETCH_DKP_SECTION_STANDING_ITEM,
    FETCH_DKP_EVENTS,
    FETCH_DKP_EVENT_ITEM,
    FETCH_DKP_ITEMS,
    FETCH_DKP_ITEM_DETAIL,
    FETCH_DKP_LOCATIONS,
    FETCH_DKP_LOCATION_ITEM,
    POST_DKP_EVENT,
    FETCH_DKP_RECENT_EVENTS,
    FETCH_DKP_ACTIVE_EVENTS,
    POST_DKP_ATTENDANCE,
    FETCH_DKP_ENTITIES,
    FETCH_DKP_ENTITY_ITEM,
    POST_DKP_ITEM,
    POST_DKP_ENTITY,
    POST_DKP_LOCATION,
    UPDATE_DKP_LOCATION,
    DELETE_DKP_LOCATION,
    DELETE_DKP_ATTENDANCE, UPDATE_DKP_ATTENDANCE, FETCH_AWARD_RECIPIENTS, FETCH_POLLS, POST_POLL, FETCH_DKP_SECTION_STANDINGS_EVENT_TOTAL, FETCH_DKP_USER_EVENTS, FETCH_DKP_ITEM_HISTORY, FETCH_SCREENSHOTS, POST_SCREENSHOT, FETCH_SCREENSHOT_ITEM, FETCH_DKP_RESOURCES, FETCH_DKP_RESOURCE_ITEM, UPDATE_DKP_RESOURCE, DELETE_DKP_RESOURCE, POST_DKP_RESOURCE, UPDATE_DKP_RESOURCE_CONTRIBUTION, POST_DKP_RESOURCE_CONTRIBUTION, DELETE_DKP_RESOURCE_CONTRIBUTION, FETCH_DKP_RESOURCE_CONTRIBUTIONS, FETCH_DKP_RESOURCE_CONTRIBUTION_ITEM, UPDATE_CODEX, DELETE_CODEX,
} from './actions';
import { normalize } from 'normalizr';
import {
    newsList,
    feedList,
    applicationSchema,
    applicationList,
    chapterList,
    rankList,
    awardList,
    awardSummaryList,
    applicationQuestionList,
    newsSchema,
    applicationInterestList,
    chapterMemberList,
    awardRecipientList,
    awardCategoryList,
    userSchema,
    feedSchema,
    userOnlineList,
    chapterSchema,
    chapterDivisionList,
    chapterDivisionSchema,
    awardSchema,
    awardCategorySchema,
    rankSchema,
    notificationList,
    notificationSchema,
    chapterMemberSchema,
    commentList,
    commentSchema,
    quotesList,
    quoteSchema,
    codexList,
    codexSchema,
    dkpList,
    dkpSchema,
    dkpStandingsSchema,
    dkpStandingsList,
    eventList,
    eventSchema,
    itemSchema,
    itemList,
    locationList,
    locationSchema,
    eventAttendanceSchema,
    eventEntitySchema,
    eventItemSchema, entityList, entitySchema, pollSchema, pollList, eventItemList, screenshotList, screenshotSchema, resourceList, resourceSchema, resourceContributionList, resourceContributionSchema
} from "./schemas";
import { merge, assign, omit } from 'lodash';

const loggedInOptimistic = () => {
    if (localStorage.getItem('token')) {
        return true;
    }
    return false;
};

// INIT

const initReducer = (
    state = false,
    action ) => {
    switch(action.type) {
        case INIT_SUCCESS:
            return true;
        case INIT_RESET:
            return false;
        default:
            return state;

    }
};

// Side panels
const panelReducer = (
    state = {
        leftPanelOpen: true,
        rightPanelOpen: true,

    }, { type, panel }) => {
    switch(panel) {
        case "left":
            return { ...state, leftPanelOpen: !state.leftPanelOpen };
        case "right":
            return { ...state, rightPanelOpen: !state.rightPanelOpen };
        default:
            return state;
    }
};

//Authentication Reducer
const authReducer = (state =  {
        loggedIn: loggedInOptimistic(),
        token: localStorage.getItem('token'),
        loginError: null,
        registerError: null,
        pending: 0,
        currentUser: {
            displayName: null,
        },
        groups: [],
        permissions: [],
        passwordReset: false,
    }
    , action ) => {
    switch (action.type) {
        case AUTH:
        case AUTH_REGISTER:
        case AUTH_INIT:
        case UPDATE_PROFILE:
        case UPDATE_AVATAR:
        case AUTH_VERIFY: {
            return {
                ...state,
                pending: state.pending + 1,
            }
        }
        case success(AUTH):
        case success(AUTH_INIT): {
            localStorage.setItem('token', action.data.token);
            return {
                ...state,
                loggedIn: true,
                token: action.data.token,
                currentUser: action.data.user,
                groups: action.data.user.groups,
                permissions: action.data.user.permissions,
                pending: state.pending - 1,
                error: null
            };
        }
        case success(UPDATE_PROFILE):
        case success(UPDATE_AVATAR):
        case success(AUTH_VERIFY): {
            return {
                ...state,
                currentUser: action.data,
                groups: action.data.groups,
                permissions: action.data.permissions,
                pending: state.pending - 1,
                error: null
            }
        }
        case success(AUTH_REGISTER):
            localStorage.setItem('token', action.data.token);
            return {
                ...state,
                loggedIn: true,
                token: action.data.token,
                pending: state.pending - 1,
                error: null
            };
        case success(AUTH_RESET):
        case success(AUTH_GET_RESET):
            return {
                ...state,
                passwordReset: true,
            };
        case error(AUTH):
        case error(AUTH_INIT):{
            localStorage.removeItem('token');
            return {
                ...state,
                loggedIn: false,
                token: null,
                loginError: action.error.response.data,
                pending: state.pending - 1,
            };
        }
        case error(AUTH_REGISTER): {
            localStorage.removeItem('token');
            return {
                ...state,
                loggedIn: false,
                token: null,
                registerError: action.error.response.data,
                pending: state.pending - 1,
            };
        }
        case error(UPDATE_PROFILE):
        case error(UPDATE_AVATAR):
        case error(AUTH_VERIFY): {
            return {
                ...state,
                pending: state.pending - 1,
                error: action.error.response.data,
            }
        }
        case DE_AUTH: {
            localStorage.removeItem('token');
            return {
                ...state,
                loggedIn: false,
                currentUser: [],
                token: null,
                error: null,
                pending: 0,
                groups: [],
                permissions: [],
            }
        }
        default:
            return state;
    }
};


// Activity Feed Reducer

const feedReducer = (
    state = {
        data: [],
        pending: 0,
        error: null,
        limit: 30,
        offset: 0,
        more: true,
    }, action ) => {
    switch (action.type) {
        case FETCH_FEED:
        case FETCH_FEED_ITEM:
        case POST_FEED: {
            return {
                ...state,
                pending: state.pending + 1,

            };
        }
        case success(FETCH_FEED): {
            let nextPage = false;
            if (action.data.next) {
                nextPage = true;
            }
            return {
                ...state,
                data: merge({}, state.data, normalize(action.data.results, feedList).entities.feed),
                pending: state.pending - 1,
                error: null,
                offset: state.offset + 30,
                more: nextPage,
            };
        }
        case success(FETCH_FEED_ITEM): {
            return {
                ...state,
                data: merge({}, state.data, normalize(action.data, feedSchema).entities.feed),
                pending: state.pending - 1,
                error: null,
            }
        }
        case error(FETCH_FEED):
        case error(FETCH_FEED_ITEM):
        case error(POST_FEED):{
            return {
                ...state,
                pending: state.pending - 1,
                error: action.error,
            };
        }
        case success(POST_FEED): {
            return {
                ...state,
                data: merge({}, state.data, normalize(action.data, feedSchema).entities.feed),
                offset: state.offset + 1,
                pending: state.pending - 1,
                error: null,
            }
        }
        case abort(FETCH_FEED):
        case abort(FETCH_FEED_ITEM):
        case abort(POST_FEED): {
            return {
                ...state,
                pending: state.pending - 1,
            }
        }
        default:
            return state;
    }
};

// News Reducer

const newsReducer = (
        state = {
            data: [],
            pending: 0,
            error: null,
            page: 1,
            more: true,
        }, action ) => {
    switch (action.type) {
        case FETCH_NEWS:
        case FETCH_NEWS_ITEM: {
            return {
                ...state,
                pending: state.pending + 1,
            };
        }
        case success(FETCH_NEWS): {
            let nextPage = false;
            if (action.data.next) {
                nextPage = true;
            }
            return {
                ...state,
                data: merge({}, state.data, normalize(action.data.results, newsList).entities.news),
                pending: state.pending - 1,
                error: null,
                page: state.page + 1,
                more: nextPage,
            };
        }
        case success(FETCH_NEWS_ITEM): {
            return {
                ...state,
                data: merge({}, state.data, normalize(action.data, newsSchema).entities.news),
                pending: state.pending -1,
            }
        }
        case error(FETCH_NEWS):
        case error(FETCH_NEWS_ITEM): {
            return {
                ...state,
                pending: state.pending -1,
                error: action.error,
            };
        }
        case abort(FETCH_NEWS):
        case abort(FETCH_NEWS_ITEM): {
            return {
                ...state,
                pending: state.pending -1,
            }
        }
        default:
            return state;
    }
};

// Awards Reducer

const awardsReducer = (
    state = [], action ) => {
    switch (action.type) {
        case success(FETCH_AWARDS):
            return merge({}, state, normalize(action.data, awardList).entities.awards);
        case success(FETCH_AWARD_ITEM):
            return merge({}, state, normalize(action.data, awardSchema).entities.awards);
        case success(FETCH_AWARD_SUMMARY):
            return merge({}, state, normalize(action.data, awardSummaryList).entities.awards);
        case success(FETCH_NOTIFICATIONS):
            return merge({}, state, normalize(action.data.results, notificationList).entities.awards);
        default:
            return state;
    }
};

const awardCategoriesReducer = (
    state = {
        data: [],
        pending: 0,
        error: null,
    }, action ) => {
    switch (action.type) {
        case FETCH_AWARD_CATEGORIES:
        case FETCH_AWARD_SUMMARY:
        case FETCH_AWARD_CATEGORY_ITEM:
            return {
                ...state,
                pending: state.pending + 1,
            };
        case success(FETCH_AWARD_CATEGORIES):
            return {
                ...state,
                data: merge({}, state.data, normalize(action.data, awardCategoryList).entities.awardCategories),
                pending: state.pending - 1,
            };
        case success(FETCH_AWARD_CATEGORY_ITEM): {
            return {
                ...state,
                data: merge({}, state.data, normalize(action.data, awardCategorySchema).entities.awardCategories),
                pending: state.pending - 1,
            };
        }
        case success(FETCH_AWARD_SUMMARY):
            return {
                ...state,
                data: merge({}, state.data, normalize(action.data, awardSummaryList).entities.awardCategories),
                pending: state.pending - 1,
            };
        case error(FETCH_AWARD_CATEGORIES):
        case error(FETCH_AWARD_SUMMARY):
        case error(FETCH_AWARD_CATEGORY_ITEM):
            return {
                ...state,
                error: action.data.error,
                pending: state.pending -1,
            };
        case abort(FETCH_AWARD_CATEGORIES):
        case abort(FETCH_AWARD_SUMMARY):
        case abort(FETCH_AWARD_CATEGORY_ITEM):
            return {
                ...state,
                pending: state.pending -1,
            };
        default:
            return state;
    }
};

const awardRecipientsReducer = (
    state = {
        data: [],
        pending: 0,
        error: null,
        page: 1,
        more: false,
    }, action ) => {
    switch (action.type) {
        case FETCH_AWARD_RECIPIENTS:
        case FETCH_USER_AWARDS:
            return {
                ...state,
                pending: state.pending + 1,
            };
        case success(FETCH_USER_AWARDS):
            return {
                ...state,
                data: merge({}, state.data, normalize(action.data, awardRecipientList).entities.awardRecipients),
                pending: state.pending - 1,
            };
        case success(FETCH_AWARD_RECIPIENTS):
            let nextPage = false;
            if (action.data.next) {
                nextPage = true;
            }
            return {
                ...state,
                data: merge({}, state.data, normalize(action.data.results, awardRecipientList).entities.awardRecipients),
                pending: state.pending - 1,
                error: null,
                page: state.page + 1,
                more: nextPage,
            };
        case error(FETCH_AWARD_RECIPIENTS):
        case error(FETCH_USER_AWARDS):
            return {
                ...state,
                error: action.data.error,
                pending: state.pending -1,
            };
        case abort(FETCH_AWARD_RECIPIENTS):
        case abort(FETCH_USER_AWARDS):
            return {
                ...state,
                pending: state.pending -1,
            };
        default:
            return state;
    }
};


//const awardSummaryReducer = requestsReducer({ actionType: FETCH_AWARD_SUMMARY, multiple:true });

// Ranks Reducer

//const ranksReducer = requestsReducer({ actionType: FETCH_RANKS, multiple:true });

const ranksReducer = (
    state = [], action ) => {
    switch (action.type) {
        case success(FETCH_RANKS):
            return merge({}, state, normalize(action.data, rankList).entities.ranks);
        case success(FETCH_RANK_ITEM):
            return merge({}, state, normalize(action.data, rankSchema).entities.ranks);
        default:
            return state;
    }
};

// Chapters Reducer

//const chaptersReducer = requestsReducer({ actionType: FETCH_CHAPTERS, multiple:true });

const chaptersReducer = (
    state = [], action ) => {
    switch (action.type) {
        case success(FETCH_CHAPTER_ITEM): {
            return merge({}, state, normalize(action.data, chapterSchema).entities.chapters);
        }
        case success(FETCH_CHAPTERS):
            return merge({}, state, normalize(action.data, chapterList).entities.chapters);
        default:
            return state;
    }
};


// Divisions Reducer

const divisionsReducer = (
    state = {
        data: [],
        pending: 0,
        error: null,
    }, action ) => {
    switch (action.type) {
        case FETCH_DIVISIONS:
        case FETCH_CHAPTER_DIVISION_ITEM: {
            return {
                ...state,
                pending: state.pending + 1,
            };
        }
        case success(FETCH_DIVISIONS): {
            return {
                ...state,
                data: merge({}, state.data, normalize(action.data, chapterDivisionList).entities.chapterDivisions),
                pending: state.pending - 1,
                error: null,
            };
        }
        case success(FETCH_CHAPTER_DIVISION_ITEM): {
            return {
                ...state,
                data: merge({}, state.data, normalize(action.data, chapterDivisionSchema).entities.chapterDivisions),
                pending: state.pending - 1,
                error: null,
            };
        }
        case error(FETCH_DIVISIONS):
        case error(FETCH_CHAPTER_DIVISION_ITEM): {
            return {
                ...state,
                pending: state.pending - 1,
                error: action.error,
            };
        }
        case abort(FETCH_DIVISIONS):
        case abort(FETCH_CHAPTER_DIVISION_ITEM): {
            return {
                ...state,
                pending: state.pending -1,
            }
        }
        default:
            return state;
    }
};

// Chapter Members Reducer

const chapterMembersReducer = (
        state = {
            data: [],
            pending: 0,
            error: null,
        }, action ) => {
    switch (action.type) {
        case FETCH_CHAPTER_MEMBERS:
        case FETCH_CHAPTER_MEMBER_ITEM:
        case FETCH_MEMBERSHIP_HISTORY: {
            return {
                ...state,
                pending: state.pending + 1,
            };
        }
        case success(FETCH_CHAPTER_MEMBERS):
        case success(FETCH_MEMBERSHIP_HISTORY): {
            return {
                ...state,
                data: merge({}, state.data, normalize(action.data, chapterMemberList).entities.chapterMembers),
                pending: state.pending - 1,
                error: null,
            };
        }
        case success(FETCH_CHAPTER_MEMBER_ITEM): {
            return {
                ...state,
                data: merge({}, state.data, normalize(action.data, chapterMemberSchema).entities.chapterMembers),
                pending: state.pending - 1,
                error: null,
            };
        }
        case success(FETCH_DIVISIONS): {
            return {
                ...state,
                data: merge({}, state.data, normalize(action.data, chapterDivisionList).entities.chapterMembers),
            };
        }
        case error(FETCH_CHAPTER_MEMBERS):
        case error(FETCH_CHAPTER_MEMBER_ITEM):
        case error(FETCH_MEMBERSHIP_HISTORY): {
            return {
                ...state,
                pending: state.pending - 1,
                error: action.error,
            };
        }
        case abort(FETCH_CHAPTER_MEMBERS):
        case abort(FETCH_CHAPTER_MEMBER_ITEM):
        case abort(FETCH_MEMBERSHIP_HISTORY): {
            return {
                ...state,
                pending: state.pending - 1,
            }
        }
        default:
            return state;
    }
};

// Recruitment

const recruitmentReducer = (
    state = {
        applications: [],
        questions: [],
        interests: [],
        pending: 0,
        error: null,
    }, action ) => {
    switch (action.type) {
        case FETCH_APPLICATION:
        case FETCH_USER_APPLICATIONS:
        case FETCH_APPLICATION_QUESTIONS:
        case FETCH_APPLICATION_INTERESTS:
        case FETCH_ARCHIVED_APPLICATIONS:
        case FETCH_ACTIVE_APPLICATIONS:
        case POST_STEPONE_REDO_APPLICATION:
        case POST_STEPTWO_APPLICATION:
        case POST_STEPTWO_REDO_APPLICATION:
        case POST_ESCALATE_APPLICATION:
        case POST_REDO_APPLICATION:
        case POST_ACCEPT_APPLICATION:
        case POST_REJECT_APPLICATION:
        case POST_CLOSE_APPLICATION:
            {
            return {
                ...state,
                pending: state.pending + 1,
            };
        }
        case success(FETCH_APPLICATION):
        case success(POST_STEPONE_REDO_APPLICATION):
        case success(POST_STEPTWO_APPLICATION):
        case success(POST_STEPTWO_REDO_APPLICATION):
        case success(POST_ESCALATE_APPLICATION):
        case success(POST_REDO_APPLICATION):
        case success(POST_ACCEPT_APPLICATION):
        case success(POST_REJECT_APPLICATION):
        case success(POST_CLOSE_APPLICATION):
            {
            return {
                ...state,
                applications: merge({}, state.applications, normalize(action.data, applicationSchema).entities.applications),
                pending: state.pending - 1,
                error: null,
            };
        }
        case success(FETCH_USER_APPLICATIONS):
        case success(FETCH_ARCHIVED_APPLICATIONS):
        case success(FETCH_ACTIVE_APPLICATIONS): {
            return {
                ...state,
                applications: merge({}, state.applications, normalize(action.data, applicationList).entities.applications),
                pending: state.pending - 1,
                error: null,
            };
        }
        case success(FETCH_APPLICATION_QUESTIONS): {
            return {
                ...state,
                questions: merge({}, state.questions, normalize(action.data, applicationQuestionList).entities.applicationQuestions),
                pending: state.pending - 1,
                error: null,
            }
        }
        case success(FETCH_APPLICATION_INTERESTS): {
            return {
                ...state,
                interests: merge({}, state.interests, normalize(action.data, applicationInterestList).entities.applicationInterests),
                pending: state.pending - 1,
                error: null,
            }
        }
        case success(FETCH_NOTIFICATIONS):
            return {
                ...state,
                applications: merge({}, state.applications, normalize(action.data.results, notificationList).entities.applications),
            };
        case success(FETCH_NOTIFICATION_ITEM):
        case success(NOTIFICATION_ISREAD):
            return {
                ...state,
                applications: merge({}, state.applications, normalize(action.data, notificationSchema).entities.applications),
            };
        case error(FETCH_APPLICATION):
        case error(FETCH_USER_APPLICATIONS):
        case error(FETCH_APPLICATION_QUESTIONS):
        case error(FETCH_APPLICATION_INTERESTS):
        case error(FETCH_ARCHIVED_APPLICATIONS):
        case error(FETCH_ACTIVE_APPLICATIONS):
        case error(POST_STEPONE_REDO_APPLICATION):
        case error(POST_STEPTWO_APPLICATION):
        case error(POST_STEPTWO_REDO_APPLICATION):
        case error(POST_ESCALATE_APPLICATION):
        case error(POST_REDO_APPLICATION):
        case error(POST_ACCEPT_APPLICATION):
        case error(POST_REJECT_APPLICATION):
        case error(POST_CLOSE_APPLICATION): {
            return {
                ...state,
                pending: state.pending -1,
                error: action.error,
            }
        }
        case abort(FETCH_APPLICATION):
        case abort(FETCH_USER_APPLICATIONS):
        case abort(FETCH_APPLICATION_QUESTIONS):
        case abort(FETCH_APPLICATION_INTERESTS):
        case abort(FETCH_ARCHIVED_APPLICATIONS):
        case abort(FETCH_ACTIVE_APPLICATIONS):
        case abort(POST_STEPONE_REDO_APPLICATION):
        case abort(POST_STEPTWO_APPLICATION):
        case abort(POST_STEPTWO_REDO_APPLICATION):
        case abort(POST_ESCALATE_APPLICATION):
        case abort(POST_REDO_APPLICATION):
        case abort(POST_ACCEPT_APPLICATION):
        case abort(POST_REJECT_APPLICATION):
        case abort(POST_CLOSE_APPLICATION): {
            return {
                ...state,
                pending: state.pending -1,
            }
        }
        default:
            return state;
    }
};

//Notifications

const notificationsReducer = (
    state = {
        data: [],
        pending: 0,
        error: null,
        page: 1,
        more: true,
    }, action ) => {
    switch (action.type) {
        case NOTIFICATION_ISREAD:
        case FETCH_NOTIFICATIONS:
        case FETCH_NOTIFICATION_ITEM:
            return {
                ...state,
                pending: state.pending + 1,
            };
        case success(FETCH_NOTIFICATIONS):
            let nextPage = false;
            if (action.data.next) {
                nextPage = true;
            }
            return {
                ...state,
                data: merge({}, state.data, normalize(action.data.results, notificationList).entities.notifications),
                pending: state.pending - 1,
                error: null,
                page: state.page + 1,
                more: nextPage,
            };
        case success(FETCH_NOTIFICATION_ITEM):
        case success(NOTIFICATION_ISREAD):
            return {
                ...state,
                data: merge({}, state.data, normalize(action.data, notificationSchema).entities.notifications),
                pending: state.pending - 1,
                error: null,
            };
        case error(NOTIFICATION_ISREAD):
        case error(FETCH_NOTIFICATIONS):
        case error(FETCH_NOTIFICATION_ITEM):
            return {
                ...state,
                pending: state.pending -1,
                error: action.error,
            };
        case abort(NOTIFICATION_ISREAD):
        case abort(FETCH_NOTIFICATIONS):
        case abort(FETCH_NOTIFICATION_ITEM):
            return {
                ...state,
                pending: state.pending -1,
            };
        default:
            return state;
    }
};

// Comments

const commentsReducer = (
    state = {
        data: [],
        pending: 0,
        error: null,
        page: 1,
        more: true,
    }, action ) => {
    switch (action.type) {
        case POST_COMMENT:
        case FETCH_COMMENTS:
            return {
                ...state,
                pending: state.pending + 1,
            };
        case success(FETCH_COMMENTS):
            let nextPage = false;
            if (action.data.next) {
                nextPage = true;
            }
            return {
                ...state,
                data: merge({}, state.data, normalize(action.data.results, commentList).entities.comments),
                pending: state.pending - 1,
                error: null,
                page: state.page + 1,
                more: nextPage,
            };
        case success(POST_COMMENT):
            return {
                ...state,
                data: merge({}, state.data, normalize(action.data, commentSchema).entities.comments),
                pending: state.pending - 1,
                error: null,
            };
        case error(POST_COMMENT):
        case error(FETCH_COMMENTS):
            return {
                ...state,
                pending: state.pending -1,
                error: action.error,
            };
        case abort(POST_COMMENT):
        case abort(FETCH_COMMENTS):
            return {
                ...state,
                pending: state.pending -1,
            };
        default:
            return state;
    }
};

// Media Reducers

// Quotes Reducer

const quotesReducer = (
        state = {
            data: [],
            pending: 0,
            error: null,
            page: 1,
            more: true,
        }, action ) => {
    switch (action.type) {
        case FETCH_QUOTES:
        case FETCH_QUOTE_ITEM: {
            return {
                ...state,
                pending: state.pending + 1,
            };
        }
        case success(FETCH_QUOTES): {
            let nextPage = false;
            if (action.data.next) {
                nextPage = true;
            }
            return {
                ...state,
                data: merge({}, state.data, normalize(action.data.results, quotesList).entities.quotes),
                pending: state.pending - 1,
                error: null,
                page: state.page + 1,
                more: nextPage,
            };
        }
        case success(FETCH_QUOTE_ITEM): {
            return {
                ...state,
                data: merge({}, state.data, normalize(action.data, quoteSchema).entities.quotes),
                pending: state.pending -1,
            }

        }
        case error(FETCH_QUOTES):
        case error(FETCH_QUOTE_ITEM): {
            return {
                ...state,
                pending: state.pending -1,
                error: action.error,
            };
        }
        case abort(FETCH_QUOTES):
        case abort(FETCH_QUOTE_ITEM): {
            return {
                ...state,
                pending: state.pending -1,
            }
        }
        default:
            return state;
    }
};

// Codex Reducer

const codexReducer = (
        state = {
            data: [],
            pending: 0,
            error: null,
            page: 1,
            more: true,
        }, action ) => {
    switch (action.type) {
        case POST_CODEX:
        case UPDATE_CODEX:
        case DELETE_CODEX:
        case FETCH_CODEX:
        case FETCH_CODEX_ITEM: {
            return {
                ...state,
                pending: state.pending + 1,
            };
        }
        case success(FETCH_CODEX): {
            let nextPage = false;
            if (action.data.next) {
                nextPage = true;
            }
            return {
                ...state,
                data: merge({}, state.data, normalize(action.data.results, codexList).entities.codex),
                pending: state.pending - 1,
                error: null,
                page: state.page + 1,
                more: nextPage,
            };
        }
        case success(POST_CODEX):
        case success(UPDATE_CODEX):
        case success(FETCH_CODEX_ITEM): {
            return {
                ...state,
                data: merge({}, state.data, normalize(action.data, codexSchema).entities.codex),
                pending: state.pending -1,
            }

        }
        case success(DELETE_CODEX): {
            return {
                ...state,
                data: omit(state.data, action.response.request.responseURL.split('/')[7]), // Probably not an accurate index
                pending: state.pending -1,
                error: null
            }
        }
        case error(POST_CODEX):
        case error(UPDATE_CODEX):
        case error(DELETE_CODEX):
        case error(FETCH_CODEX):
        case error(FETCH_CODEX_ITEM): {
            return {
                ...state,
                pending: state.pending -1,
                error: action.error,
            };
        }
        case abort(POST_CODEX):
        case abort(UPDATE_CODEX):
        case abort(DELETE_CODEX):
        case abort(FETCH_CODEX):
        case abort(FETCH_CODEX_ITEM): {
            return {
                ...state,
                pending: state.pending -1,
            }
        }
        default:
            return state;
    }
};

const dkpReducer = (
        state = {
            data: [],
            standings: [],
            eventsTotal: [],
            pending: 0,
            error: null,
            page: 1,
            more: true,
        }, action ) => {
    switch (action.type) {
        case FETCH_DKP_SECTION_STANDINGS:
        case FETCH_DKP_SECTION_STANDING_ITEM:
        case FETCH_DKP_SECTIONS:
        case FETCH_DKP_SECTION_ITEM: {
            return {
                ...state,
                pending: state.pending + 1,
            }
        }
        case success(FETCH_DKP_SECTIONS): {
            return {
                ...state,
                data: merge({}, state.data, normalize(action.data, dkpList).entities.dkp),
                pending: state.pending - 1,
                error: null,

            };
        }
        case success(FETCH_DKP_SECTION_ITEM): {
            return {
                ...state,
                data: merge({}, state.data, normalize(action.data, dkpSchema).entities.dkp),
                pending: state.pending -1,
                error: null,
            }

        }
        case success(FETCH_DKP_RESOURCE_ITEM): {
            return {
                ...state,
                data: merge({}, state.data, normalize(action.data, resourceSchema).entities.dkp),
            }
        }
        case success(FETCH_DKP_RESOURCES): {
            return {
                ...state,
                data: merge({}, state.data, normalize(action.data, resourceList).entities.dkp),
            }
        }
        case success(FETCH_DKP_SECTION_STANDINGS): {
            return {
                ...state,
                standings: merge({}, state.standings, normalize(action.data, dkpStandingsList).entities.dkpStandings),
                pending: state.pending - 1,
                error: null,
            }
        }
        case success(FETCH_DKP_SECTION_STANDING_ITEM): {
            return {
                ...state,
                standings: merge({}, state.standings, normalize(action.data, dkpStandingsSchema).entities.dkpStandings),
                pending: state.pending - 1,
                error: null,
            }
        }
        case error(FETCH_DKP_SECTION_STANDINGS):
        case error(FETCH_DKP_SECTION_STANDING_ITEM):
        case error(FETCH_DKP_SECTIONS):
        case error(FETCH_DKP_SECTION_ITEM): {
            return {
                ...state,
                pending: state.pending -1,
                error: action.error,
            };
        }
        case abort(FETCH_DKP_SECTION_STANDINGS):
        case error(FETCH_DKP_SECTION_STANDING_ITEM):
        case abort(FETCH_DKP_SECTIONS):
        case abort(FETCH_DKP_SECTION_ITEM): {
            return {
                ...state,
                pending: state.pending -1,
            }
        }
        default:
            return state;
    }
};

const eventsReducer = (
        state = {
            data: [],
            pending: 0,
            error: null,
            page: 1,
            more: true,
        }, action ) => {
    switch (action.type) {
        case POST_DKP_EVENT:
        case FETCH_DKP_EVENTS:
        case FETCH_DKP_USER_EVENTS:
        case FETCH_DKP_RECENT_EVENTS:
        case FETCH_DKP_ACTIVE_EVENTS:
        case FETCH_DKP_EVENT_ITEM: {
            return {
                ...state,
                pending: state.pending + 1,
            }
        }
        case success(POST_DKP_EVENT): {
            return {
                ...state,
                data: merge({}, state.data, normalize(action.data, eventSchema).entities.events),
                pending: state.pending - 1,
            }
        }
        case success(FETCH_DKP_EVENTS): {
            let nextPage = false;
            if (action.data.next) {
                nextPage = true;
            }
            return {
                ...state,
                data: merge({}, state.data, normalize(action.data.results, eventList).entities.events),
                pending: state.pending - 1,
                error: null,
                page: state.page + 1,
                more: nextPage,
            };
        }
        case success(FETCH_DKP_USER_EVENTS):
        case success(FETCH_DKP_RECENT_EVENTS):
        case success(FETCH_DKP_ACTIVE_EVENTS): {
            return {
                ...state,
                data: merge({}, state.data, normalize(action.data, eventList).entities.events),
                pending: state.pending - 1,
                error: null,
            };
        }
        case success(FETCH_DKP_EVENT_ITEM): {
            return {
                ...state,
                data: assign({}, state.data, normalize(action.data, eventSchema).entities.events), // Merge did not properly clear the attendee array
                pending: state.pending -1,
                error: null,
            }

        }
        case error(POST_DKP_EVENT):
        case error(FETCH_DKP_EVENTS):
        case error(FETCH_DKP_ACTIVE_EVENTS):
        case error(FETCH_DKP_EVENT_ITEM): {
            return {
                ...state,
                pending: state.pending -1,
                error: action.error,
            };
        }
        case abort(POST_DKP_EVENT):
        case abort(FETCH_DKP_EVENTS):
        case abort(FETCH_DKP_ACTIVE_EVENTS):
        case abort(FETCH_DKP_EVENT_ITEM): {
            return {
                ...state,
                pending: state.pending -1,
            }
        }
        default:
            return state;
    }
};

const itemsReducer = (
        state = {
            data: [],
            pending: 0,
            error: null,
        }, action ) => {
    switch (action.type) {
        case FETCH_DKP_ITEMS:
        case FETCH_DKP_ITEM_HISTORY:
        case FETCH_DKP_ITEM_DETAIL: {
            return {
                ...state,
                pending: state.pending + 1,
            }
        }
        case success(FETCH_DKP_ITEM_HISTORY): {
            return {
                ...state,
                data: merge({}, state.data, normalize(action.data, eventItemList).entities.items),
            }
        }
        case success(FETCH_DKP_ITEMS): {
            return {
                ...state,
                data: merge({}, state.data, normalize(action.data, itemList).entities.items),
                pending: state.pending - 1,
                error: null,
            };
        }
        case success(FETCH_DKP_ITEM_DETAIL): {
            return {
                ...state,
                data: merge({}, state.data, normalize(action.data, itemSchema).entities.items),
                pending: state.pending -1,
                error: null,
            }
        }
        case success(FETCH_DKP_EVENTS): {
            return {
                ...state,
                data: merge({}, state.data, normalize(action.data.results, eventList).entities.items),
            };
        }
        case success(FETCH_DKP_USER_EVENTS):
        case success(FETCH_DKP_RECENT_EVENTS):
        case success(FETCH_DKP_ACTIVE_EVENTS): {
            return {
                ...state,
                data: merge({}, state.data, normalize(action.data, eventList).entities.items),
            };
        }
        case success(FETCH_DKP_EVENT_ITEM): {
            return {
                ...state,
                data: merge({}, state.data, normalize(action.data, eventSchema).entities.items),
            };
        }
        case success(POST_DKP_ITEM): {
            return {
                ...state,
                data: merge({}, state.data, normalize(action.data, eventItemSchema).entities.items),
            };
        }
        case error(FETCH_DKP_ITEMS):
        case error(FETCH_DKP_ITEM_DETAIL): {
            return {
                ...state,
                pending: state.pending -1,
                error: action.error,
            };
        }
        case abort(FETCH_DKP_ITEMS):
        case abort(FETCH_DKP_ITEM_DETAIL): {
            return {
                ...state,
                pending: state.pending -1,
            }
        }
        default:
            return state;
    }
};

const entitiesReducer = (
        state = {
            data: [],
            pending: 0,
            error: null,
        }, action ) => {
    switch (action.type) {
        case FETCH_DKP_ENTITIES:
        case FETCH_DKP_ENTITY_ITEM: {
           return {
               ...state,
               pending: state.pending + 1,
            };
        }
        case success(FETCH_DKP_ENTITIES): {
            return {
                ...state,
                data: merge({}, state.data, normalize(action.data, entityList).entities.entities),
                pending: state.pending - 1,
                error: null,
            };
        }
        case success(FETCH_DKP_ENTITY_ITEM): {
            return {
                ...state,
                data: merge({}, state.data, normalize(action.data, entitySchema).entities.entities),
                pending: state.pending - 1,
                error: null,
            };
        }
        case success(FETCH_DKP_EVENTS): {
            return {
                ...state,
                data: merge({}, state.data, normalize(action.data.results, eventList).entities.entities),
            };
        }
        case success(FETCH_DKP_USER_EVENTS):
        case success(FETCH_DKP_RECENT_EVENTS):
        case success(FETCH_DKP_ACTIVE_EVENTS): {
            return {
                ...state,
                data: merge({}, state.data, normalize(action.data, eventList).entities.entities),
            };
        }
        case success(FETCH_DKP_EVENT_ITEM): {
            return {
                ...state,
                data: merge({}, state.data, normalize(action.data, eventSchema).entities.entities),
            };
        }
        case error(FETCH_DKP_ENTITIES):
        case error(FETCH_DKP_ENTITY_ITEM): {
            return {
                ...state,
                pending: state.pending -1,
                error: action.error,
            };
        }
        case abort(FETCH_DKP_LOCATIONS):
        case abort(FETCH_DKP_ENTITY_ITEM): {
            return {
                ...state,
                pending: state.pending -1,
            };
        }
        default:
            return state;
    }
};

const locationsReducer = (
        state = {
            data: [],
            pending: 0,
            error: null,
            page: 1,
            more: true,
        }, action ) => {
    switch (action.type) {
        case FETCH_DKP_LOCATIONS:
        case FETCH_DKP_LOCATION_ITEM:
        case UPDATE_DKP_LOCATION:
        case POST_DKP_LOCATION:
        case DELETE_DKP_LOCATION: {
            return {
                ...state,
                pending: state.pending + 1,
            };
        }
        case success(FETCH_DKP_LOCATIONS): {
            let nextPage = false;
            if (action.data.next) {
                nextPage = true;
            }
            return {
                ...state,
                data: merge({}, state.data, normalize(action.data.results, locationList).entities.locations),
                pending: state.pending - 1,
                error: null,
                page: state.page + 1,
                more: nextPage,
            };
        }
        case success(FETCH_DKP_LOCATION_ITEM):
        case success(POST_DKP_LOCATION):
        case success(UPDATE_DKP_LOCATION):
            {
            return {
                ...state,
                data: merge({}, state.data, normalize(action.data, locationSchema).entities.locations),
                pending: state.pending -1,
                error: null,
            };
        }
        case success(DELETE_DKP_LOCATION): {
            return {
                ...state,
                data: omit(state.data, action.response.request.responseURL.split('/')[7]),
                pending: state.pending -1,
                error: null
            }
        }
        case success(FETCH_DKP_EVENTS): {
            return {
                ...state,
                data: merge({}, state.data, normalize(action.data.results, eventList).entities.locations),
            };
        }
        case success(FETCH_DKP_USER_EVENTS):
        case success(FETCH_DKP_RECENT_EVENTS):
        case success(FETCH_DKP_ACTIVE_EVENTS): {
            return {
                ...state,
                data: merge({}, state.data, normalize(action.data, eventList).entities.locations),
            };
        }
        case success(FETCH_DKP_EVENT_ITEM): {
            return {
                ...state,
                data: merge({}, state.data, normalize(action.data, eventSchema).entities.locations),
            };
        }
        case error(FETCH_DKP_LOCATIONS):
        case error(FETCH_DKP_LOCATION_ITEM): {
            return {
                ...state,
                pending: state.pending -1,
                error: action.error,
            };
        }
        case abort(FETCH_DKP_LOCATIONS):
        case abort(FETCH_DKP_LOCATION_ITEM): {
            return {
                ...state,
                pending: state.pending -1,
            };
        }
        default:
            return state;
    }
};

const eventEntityReducer = (
        state = {
            data: [],
            pending: 0,
            error: null,
        }, action ) => {
    switch (action.type) {
        case POST_DKP_ENTITY:
            return {
                ...state,
                pending: state.pending +1,
            }
        case success(FETCH_DKP_EVENTS): {
            return {
                ...state,
                data: merge({}, state.data, normalize(action.data.results, eventList).entities.eventEntities),
            };
        }
        case success(FETCH_DKP_USER_EVENTS):
        case success(FETCH_DKP_ACTIVE_EVENTS):
        case success(FETCH_DKP_RECENT_EVENTS): {
            return {
                ...state,
                data: merge({}, state.data, normalize(action.data, eventList).entities.eventEntities),
            };
        }
        case success(FETCH_DKP_EVENT_ITEM): {
            return {
                ...state,
                data: merge({}, state.data, normalize(action.data, eventSchema).entities.eventEntities),
            };
        }
        case success(POST_DKP_ENTITY): {
            return {
                ...state,
                data: merge({}, state.data, normalize(action.data, eventEntitySchema).entities.eventEntities),
                error: null,
                pending: state.pending -1,
            };
        }
        case error(POST_DKP_ENTITY): {
            return {
                ...state,
                error: action.error.response.data,
                pending: state.pending -1,
            };
        }
        default:
            return state;
    }
};

const eventAttendanceReducer = (
        state = {
            data: [],
            pending: 0,
            error: null,
        }, action ) => {
    switch (action.type) {
        case POST_DKP_ATTENDANCE:
        case UPDATE_DKP_ATTENDANCE:
        case DELETE_DKP_ATTENDANCE: {
            return {
                ...state,
                pending: state.pending + 1,
            };
        }
        case success(POST_DKP_ATTENDANCE):
        case success(UPDATE_DKP_ATTENDANCE): {
            return {
                ...state,
                data: merge({}, state.data, normalize(action.data, eventAttendanceSchema).entities.attendees),
                pending: state.pending - 1,
            }
        }

        case success(FETCH_DKP_EVENTS): {
            return {
                ...state,
                data: merge({}, state.data, normalize(action.data.results, eventList).entities.attendees),
            };
        }
        case success(FETCH_DKP_USER_EVENTS):
        case success(FETCH_DKP_ACTIVE_EVENTS):
        case success(FETCH_DKP_RECENT_EVENTS): {
            return {
                ...state,
                data: merge({}, state.data, normalize(action.data, eventList).entities.attendees),
            };
        }
        case success(FETCH_DKP_EVENT_ITEM): {
            return {
                ...state,
                data: merge({}, state.data, normalize(action.data, eventSchema).entities.attendees),
            };
        }
        case error(POST_DKP_ATTENDANCE): {
            return {
                ...state,
                pending: state.pending -1,
                error: action.error,
            };
        }
        case abort(POST_DKP_ATTENDANCE): {
            return {
                ...state,
                pending: state.pending -1,
            };
        }
        default:
            return state;
    }
};

const eventItemReducer = (
        state = {
            data: [],
            pending: 0,
            error: null,
        }, action ) => {
    switch (action.type) {
        case FETCH_DKP_ITEM_HISTORY:
        case POST_DKP_ITEM: {
            return {
                ...state,
                pending: state.pending + 1,
            };
        }
        case success(POST_DKP_ITEM): {
            return {
                ...state,
                data: merge({}, state.data, normalize(action.data, eventItemSchema).entities.eventItems),
            };
        }
        case success(FETCH_DKP_EVENTS): {
            return {
                ...state,
                data: merge({}, state.data, normalize(action.data.results, eventList).entities.eventItems),
            };
        }
        case success(FETCH_DKP_USER_EVENTS):
        case success(FETCH_DKP_ACTIVE_EVENTS):
        case success(FETCH_DKP_RECENT_EVENTS): {
            return {
                ...state,
                data: merge({}, state.data, normalize(action.data, eventList).entities.eventItems),
            };
        }
        case success(FETCH_DKP_EVENT_ITEM): {
            return {
                ...state,
                data: merge({}, state.data, normalize(action.data, eventSchema).entities.eventItems),
            };
        }
        case success(FETCH_DKP_ITEM_HISTORY): {
            return {
                ...state,
                data: merge({}, state.data, normalize(action.data, eventItemList).entities.eventItems)
            }
        }
        case error(POST_DKP_ITEM): {
            return {
                ...state,
                pending: state.pending -1,
            };
        }
        case abort(POST_DKP_ITEM): {
            return {
                ...state,
                pending: state.pending -1,
            };
        }
        default:
            return state;
    }
};

const pollReducer = (
        state = {
            data: [],
            pending: 0,
            error: null,
        }, action ) => {
    switch (action.type) {
        case POST_POLL:
        case FETCH_POLLS: {
            return {
                ...state,
                pending: state.pending + 1,
            };
        }
        case success(POST_POLL): {
            return {
                ...state,
                data: merge({}, state.data, normalize(action.data, pollSchema).entities.polls),
                pending: state.pending -1,
            };
        }
        case success(FETCH_POLLS): {
            return {
                ...state,
                data: merge({}, state.data, normalize(action.data, pollList).entities.polls),
                pending: state.pending -1,
            };
        }
        case error(POST_POLL):
        case error(FETCH_POLLS): {
            return {
                ...state,
                pending: state.pending -1,
            };
        }
        case abort(POST_POLL): 
        case abort(FETCH_POLLS): {
            return {
                ...state,
                pending: state.pending -1,
            };
        }
        default:
            return state;
    }
};

const pollItemReducer = (
    state = {
        data: [],
        pending: 0,
        error: null,
    }, action ) => {
switch (action.type) {
        case POST_POLL:
        case FETCH_POLLS: {
            return {
                ...state,
                pending: state.pending + 1,
            };
        }
        case success(POST_POLL): {
            return {
                ...state,
                data: merge({}, state.data, normalize(action.data, pollSchema).entities.pollItems),
                pending: state.pending -1,
            };
        }
        case success(FETCH_POLLS): {
            return {
                ...state,
                data: merge({}, state.data, normalize(action.data, pollList).entities.pollItems),
                pending: state.pending -1,
            };
        }
        case error(POST_POLL):
        case error(FETCH_POLLS): {
            return {
                ...state,
                pending: state.pending -1,
            };
        }
        case abort(POST_POLL): 
        case abort(FETCH_POLLS): {
            return {
                ...state,
                pending: state.pending -1,
            };
        }
        default:
            return state;
    }
};

const screenshotReducer = (
    state = {
        data: [],
        pending: 0,
        error: null,
        page: 1,
        more: true,
    }, action ) => {
switch (action.type) {
        case FETCH_SCREENSHOT_ITEM:
        case POST_SCREENSHOT:
        case FETCH_SCREENSHOTS: {
            return {
                ...state,
                pending: state.pending + 1,
            };
        }
        case success(FETCH_SCREENSHOTS): {
            let nextPage = false;
            if (action.data.next) {
                nextPage = true;
            }
            return {
                ...state,
                data: merge({}, state.data, normalize(action.data.results, screenshotList).entities.screenshots),
                pending: state.pending -1,
                page: state.page + 1,
                more: nextPage,
            };
        }
        case success(FETCH_SCREENSHOT_ITEM):
        case success(POST_SCREENSHOT): {
            return {
                ...state,
                data: merge({}, state.data, normalize(action.data, screenshotSchema).entities.screenshots),
                pending: state.pending -1,
            }
        }
        case error(FETCH_SCREENSHOT_ITEM):
        case error(POST_SCREENSHOT):
        case error(FETCH_SCREENSHOTS): {
            return {
                ...state,
                pending: state.pending -1,
            };
        }
        case abort(FETCH_SCREENSHOT_ITEM):
        case abort(POST_SCREENSHOT):
        case abort(FETCH_SCREENSHOTS): {
            return {
                ...state,
                pending: state.pending -1,
            };
        }
        default:
            return state;
    }
};

const resourcesReducer = (
    state = {
        data: [],
        pending: 0,
        error: null,
        page: 1,
        more: true,
    }, action ) => {
    switch (action.type) {
        case FETCH_DKP_RESOURCES:
        case FETCH_DKP_RESOURCE_ITEM:
        case UPDATE_DKP_RESOURCE:
        case POST_DKP_RESOURCE:
        case DELETE_DKP_RESOURCE: {
            return {
                ...state,
                pending: state.pending + 1,
            };
        }
        case success(FETCH_DKP_RESOURCES): {
            let nextPage = false;
            if (action.data.next) {
                nextPage = true;
            }
            return {
                ...state,
                data: merge({}, state.data, normalize(action.data, resourceList).entities.resources),
                pending: state.pending - 1,
                error: null,
                page: state.page + 1,
                more: nextPage,
            };
        }
        case success(FETCH_DKP_RESOURCE_ITEM):
        case success(POST_DKP_RESOURCE):
        case success(UPDATE_DKP_RESOURCE):
            {
            return {
                ...state,
                data: merge({}, state.data, normalize(action.data, resourceSchema).entities.resources),
                pending: state.pending -1,
                error: null,
            };
        }
        case success(DELETE_DKP_RESOURCE): {
            return {
                ...state,
                data: omit(state.data, toArray(state.data).find(resource => resource.slug === action.response.request.responseURL.split('/')[9]).id),
                pending: state.pending -1,
                error: null
            }
        }
        case error(FETCH_DKP_RESOURCES):
        case error(FETCH_DKP_RESOURCE_ITEM): {
            return {
                ...state,
                pending: state.pending -1,
                error: action.error,
            };
        }
        case abort(FETCH_DKP_RESOURCES):
        case abort(FETCH_DKP_RESOURCE_ITEM): {
            return {
                ...state,
                pending: state.pending -1,
            };
        }
        default:
            return state;
    }
};

const resourceContributionsReducer = (
    state = {
        data: [],
        pending: 0,
        error: null,
        page: 1,
        more: true,
    }, action ) => {
    switch (action.type) {
        case FETCH_DKP_RESOURCE_CONTRIBUTIONS:
        case FETCH_DKP_RESOURCE_CONTRIBUTION_ITEM:
        case UPDATE_DKP_RESOURCE_CONTRIBUTION:
        case POST_DKP_RESOURCE_CONTRIBUTION:
        case DELETE_DKP_RESOURCE_CONTRIBUTION: {
            return {
                ...state,
                pending: state.pending + 1,
            };
        }
        case success(FETCH_DKP_RESOURCE_CONTRIBUTIONS): {
            let nextPage = false;
            if (action.data.next) {
                nextPage = true;
            }
            return {
                ...state,
                data: merge({}, state.data, normalize(action.data.results, resourceContributionList).entities.resourceContributions),
                pending: state.pending - 1,
                error: null,
                page: state.page + 1,
                more: nextPage,
            };
        }
        case success(FETCH_DKP_RESOURCE_CONTRIBUTION_ITEM):
        case success(POST_DKP_RESOURCE_CONTRIBUTION):
        case success(UPDATE_DKP_RESOURCE_CONTRIBUTION):
            {
            return {
                ...state,
                data: merge({}, state.data, normalize(action.data, resourceContributionSchema).entities.resourceContributions),
                pending: state.pending -1,
                error: null,
            };
        }
        case success(DELETE_DKP_RESOURCE_CONTRIBUTION): {
            return {
                ...state,
                data: omit(state.data, action.response.request.responseURL.split('/')[11]),
                pending: state.pending -1,
                error: null
            }
        }
        case error(FETCH_DKP_RESOURCE_CONTRIBUTIONS):
        case error(FETCH_DKP_RESOURCE_CONTRIBUTION_ITEM): {
            return {
                ...state,
                pending: state.pending -1,
                error: action.error,
            };
        }
        case abort(FETCH_DKP_RESOURCE_CONTRIBUTIONS):
        case abort(FETCH_DKP_RESOURCE_CONTRIBUTION_ITEM): {
            return {
                ...state,
                pending: state.pending -1,
            };
        }
        default:
            return state;
    }
};

/*
 * Extract users from normalized api responses and merge
 */
const usersReducer = (
    state = [], action ) => {
    switch (action.type) {
        case success(FETCH_NEWS):
            return merge({}, state, normalize(action.data.results, newsList).entities.users);
        case success(FETCH_NEWS_ITEM):
            return merge({}, state, normalize(action.data, newsSchema).entities.users);
        case success(FETCH_FEED):
            return merge({}, state, normalize(action.data.results, feedList).entities.users);
        case success(FETCH_APPLICATION):
            return merge({}, state, normalize(action.data, applicationSchema).entities.users);
        case success(FETCH_USER_APPLICATIONS):
        case success(FETCH_ARCHIVED_APPLICATIONS):
        case success(FETCH_ACTIVE_APPLICATIONS):
            return merge({}, state, normalize(action.data, applicationList).entities.users);
        case success(FETCH_CHAPTER_MEMBERS):
        case success(FETCH_MEMBERSHIP_HISTORY):
            return merge({}, state, normalize(action.data, chapterMemberList).entities.users);
        case success(UPDATE_PROFILE):
        case success(UPDATE_AVATAR):
            return merge({}, state, normalize(action.data, userSchema).entities.users);
        case SOCKET_ONLINE_USERS:
            return merge({}, state, normalize(action.data.presences, userOnlineList).entities.users);
        case success(FETCH_USER):
            return merge({}, state, normalize(action.data, userSchema).entities.users);
        case success(FETCH_FEED_ITEM):
            return merge({}, state, normalize(action.data, feedSchema).entities.users);
        case success(FETCH_NOTIFICATIONS):
            return merge({}, state, normalize(action.data.results, notificationList).entities.users);
        case success(FETCH_NOTIFICATION_ITEM):
        case success(NOTIFICATION_ISREAD):
            return merge({}, state, normalize(action.data, notificationSchema).entities.users);
        case success(FETCH_DIVISIONS):
            return merge({}, state, normalize(action.data, chapterDivisionList).entities.users);
        case success(FETCH_CHAPTER_MEMBER_ITEM):
            return merge({}, state, normalize(action.data, chapterMemberSchema).entities.users);
        case success(FETCH_COMMENTS):
            return merge({}, state, normalize(action.data.results, commentList).entities.users);
        case success(FETCH_QUOTES):
            return merge({}, state, normalize(action.data.results, quotesList).entities.users);
        case success(FETCH_QUOTE_ITEM):
            return merge({}, state, normalize(action.data, quoteSchema).entities.users);
        case success(FETCH_CODEX):
            return merge({}, state, normalize(action.data.results, codexList).entities.users);
        case success(POST_CODEX):
        case success(UPDATE_CODEX):
        case success(FETCH_CODEX_ITEM):
            return merge({}, state, normalize(action.data, codexSchema).entities.users);
        case success(FETCH_DKP_SECTION_STANDINGS):
            return merge({}, state, normalize(action.data, dkpStandingsList).entities.users);
        case success(FETCH_DKP_SECTION_STANDING_ITEM):
            return merge({}, state, normalize(action.data, dkpStandingsSchema).entities.users);
        case success(FETCH_DKP_EVENTS):
            return merge({}, state, normalize(action.data.results, eventList).entities.users);
        case success(FETCH_DKP_USER_EVENTS):
        case success(FETCH_DKP_RECENT_EVENTS):
        case success(FETCH_DKP_ACTIVE_EVENTS):
            return merge({}, state, normalize(action.data, eventList).entities.users);
        case success(FETCH_DKP_EVENT_ITEM):
            return merge({}, state, normalize(action.data, eventSchema).entities.users);
        case success(FETCH_DKP_ITEM_HISTORY):
            return merge({}, state, normalize(action.data, eventItemList).entities.users);
        case success(FETCH_AWARD_RECIPIENTS):
            return merge({}, state, normalize(action.data.results, awardRecipientList).entities.users);
        case success(FETCH_POLLS): 
            return merge({}, state, normalize(action.data, pollList).entities.users);
        case success(FETCH_SCREENSHOTS):
            return merge({}, state, normalize(action.data.results, screenshotList).entities.users);
        case success(FETCH_SCREENSHOT_ITEM):
        case success(POST_SCREENSHOT):
            return merge({}, state, normalize(action.data, screenshotSchema).entities.users);
        case success(FETCH_DKP_RESOURCE_CONTRIBUTIONS):
            return merge({}, state, normalize(action.data.results, resourceContributionList).entities.users);
        case success(FETCH_DKP_RESOURCE_CONTRIBUTION_ITEM):
        case success(POST_DKP_RESOURCE_CONTRIBUTION):
        case success(UPDATE_DKP_RESOURCE_CONTRIBUTION):
            return merge({}, state, normalize(action.data, resourceContributionSchema).entities.users);
        default:
            return state;
    }
};

const usersOnlineReducer  = (
    state = {
        presences: [],
        anonymous: null,
    }, action ) => {
    switch (action.type) {
        case SOCKET_ONLINE_USERS:
            let data = state.presences;
            if (normalize(action.data.presences, userOnlineList).entities.presences)
                data = normalize(action.data.presences, userOnlineList).entities.presences;
            else {
                data = []
            }
            return {
                ...state,
                presences: data,
                anonymous: action.data.lurkers
            };
        default:
            return state;
    }
};

export default combineReducers({
    init: initReducer,
    panel: panelReducer,
    auth: authReducer,
    feed: feedReducer,
    news: newsReducer,
    awards: awardsReducer,
    awardCategories: awardCategoriesReducer,
    awardRecipients: awardRecipientsReducer,
    ranks: ranksReducer,
    chapters: chaptersReducer,
    divisions: divisionsReducer,
    chapterMembers: chapterMembersReducer,
    recruitment: recruitmentReducer,
    notifications: notificationsReducer,
    comments: commentsReducer,

    quotes: quotesReducer,
    codex: codexReducer,
    screenshots: screenshotReducer,

    dkp: dkpReducer,
    events: eventsReducer,
    eventAttendance: eventAttendanceReducer,
    eventEntity: eventEntityReducer,
    eventItems: eventItemReducer,
    items: itemsReducer,
    entities: entitiesReducer,
    locations: locationsReducer,
    resources: resourcesReducer,
    resourceContributions: resourceContributionsReducer,

    polls: pollReducer,
    pollItems: pollItemReducer,

    users: usersReducer,
    usersOnline: usersOnlineReducer,

    loadingBar: loadingBarReducer,

    form: formReducer.plugin({
        feed: (state, action) => {
            switch(action.type) {
                case success(POST_FEED):
                    return undefined;
                default:
                    return state;
            }
        },
        chaptersForm: (state, action) => {
            switch(action.type) {
                case success(OPEN_CHAPTER):
                    return undefined;
                default:
                    return state;
            }
        },
        codex: (state, action) => {
            switch(action.type) {
                case success(POST_CODEX):
                    return undefined;
                default:
                    return state;
            }
        },
        comment: (state, action) => {
            switch(action.type) {
                case success(POST_COMMENT):
                    return undefined;
                default:
                    return state;
            }
        },
        eventsEntityForm: (state, action) => {
            switch(action.type) {
                case success(POST_DKP_ENTITY):
                    return undefined;
                default:
                    return state;
            }
        },
        eventsItemForm: (state, action) => {
            switch(action.type) {
                case success(POST_DKP_ITEM):
                    return undefined;
                default:
                    return state;
            }
        },
        eventsAttendeeForm: (state, action) => {
            switch(action.type) {
                case success(POST_DKP_ATTENDANCE):
                    return undefined;
                default:
                    return state;
            }
        },
        screenshotsForm: (state, action) => {
            switch(action.type) {
                case success(POST_SCREENSHOT):
                    return undefined;
                default:
                    return state;
            }
        },
        resourceForm: (state, action) => {
            switch(action.type) {
                case success(POST_DKP_RESOURCE):
                    return {
                        values: {
                            chapter: state.values.chapter,
                            section: state.values.section,
                            dkp: 0,
                        },
                        initial: {
                            chapter: state.values.chapter,
                            section: state.values.section,
                            dkp: 0,
                        }
                    };
                default:
                    return state;
            }
        }
    }),
});



// WEBPACK FOOTER //
// ./src/redux/reducers.js